<div class="cm-four-square-layout-container">
    <ng-content></ng-content>
</div>
